import { useTranslation } from "react-i18next";
import { OrderLocalItemResult } from "services/orders/models/OrdersTypes";

const RejectionReason = ({ order }: { order: OrderLocalItemResult | null }) => {
  const { t } = useTranslation(["Orders", "Common"]);

  if (!order?.rejectionReason?.displayName) {
    return null;
  }

  return (
    <div className="px-4 py-3">
      <h5 className="fw-bold mb-3 text-dark">{t("Common:rejectionReason")}</h5>
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center gap-3">
            <div className="bg-danger bg-opacity-10 p-3 rounded">
              <i className="icon-close text-danger fs-4"></i>
            </div>
            <div className="flex-grow-1">
              <p className="mb-0 text-dark fw-medium">{order.rejectionReason.displayName}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionReason;
